// extracted by css-extract-rspack-plugin
export default {"root":"root--lsPnYfb9ENiiKOQn","year":"year--nCn5gYVXbw5rFZhU","hint":"hint--IcPjM2OXGRMoPsmi"};